import { render, staticRenderFns } from "./display_briefing.vue?vue&type=template&id=9648ba5e&scoped=true"
import script from "./display_briefing.vue?vue&type=script&lang=js"
export * from "./display_briefing.vue?vue&type=script&lang=js"
import style0 from "./display_briefing.vue?vue&type=style&index=0&id=9648ba5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9648ba5e",
  null
  
)

export default component.exports